export interface Language {
  code: string;
  localName: string;
}

export const LANGUAGES: Language[] = [
  { code: 'cs', localName: 'Čeština' },
  { code: 'da', localName: 'Dansk' },
  { code: 'de', localName: 'Deutsch' },
  { code: 'et', localName: 'Eesti' },
  { code: 'en', localName: 'English' },
  { code: 'es', localName: 'Español' },
  { code: 'fi', localName: 'Suomi' },
  { code: 'fr', localName: 'Français' },
  { code: 'it', localName: 'Italiano' },
  { code: 'no', localName: 'Norsk' },
  { code: 'sv', localName: 'Svenska' },
];
